import HttpProxy from '@/services/HttpProxy';

export default class ClientService {
  static async getAll(parameters) {
    const apiResponse = await HttpProxy.submit({
      method: 'get',
      url: 'clients',
      parameters,
    });
    return apiResponse.data ?? null;
  }

  static async getbyId(id) {
    const apiResponse = await HttpProxy.submit({ method: 'get', url: `clients/${id}` });
    return apiResponse.data ?? null;
  }

  static async create(payload) {
    const apiResponse = await HttpProxy.submit({ method: 'post', url: 'clients', data: payload });
    return apiResponse.data ?? null;
  }

  static async update(id, payload) {
    const apiResponse = await HttpProxy.submit({ method: 'put', url: `clients/${id}`, data: payload });
    return apiResponse.data ?? null;
  }

  static async remove(id) {
    const apiResponse = await HttpProxy.submit({ method: 'delete', url: `clients/${id}` });
    return apiResponse.data ?? null;
  }
}
